import { Box } from '@factorialco/deprecated-design-system'
import { ResponsiveBar } from '@nivo/bar'

import { BreakdownWorkedTime } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/lib/breakdownWorkedTime'
import {
  BAR_HEIGHT,
  BAR_RADIUS,
  barTheme,
} from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/barsHelper'

import { barColors, generateData, keys } from './generateData'

interface Props {
  workedTimeBreakdown: BreakdownWorkedTime
}

const Bar = ({ workedTimeBreakdown }: Props) => {
  const { extraHourMinutes, regularMinues, breaksMinutes } = workedTimeBreakdown

  const data = generateData(regularMinues, extraHourMinutes, breaksMinutes)

  return (
    <Box style={{ height: `${BAR_HEIGHT}px` }}>
      <ResponsiveBar
        data={data}
        keys={keys}
        layout="horizontal"
        colors={barColors}
        enableLabel={false}
        isInteractive={false}
        animate={false}
        borderRadius={BAR_RADIUS}
        innerPadding={2}
        theme={barTheme}
      />
    </Box>
  )
}

export default Bar
